import { Alert } from '@surecompanies/core_components'
import React from 'react'

import { useStableUsRestrictedDataAccess } from './useStableUsRestrictedDataAccess'

export const REGION_RESTRICTED_DATA_BANNER_MESSAGE =
  'Region-restricted data and features may be hidden based on your access.'

/**
 * Reminds a user without US-restricted data access, on every admin page, that
 * screens can leave out records or hide actions for them. It says "may"
 * because it can't tell whether the current page actually hides anything.
 *
 * Shown once the ability has loaded, and when it has never loaded. A failed
 * background refresh keeps the last answer, so a cleared user doesn't see it
 * flash on. Like the EPS restrictions, it ignores the RBAC enforcement flag.
 */
export default function RegionRestrictedDataBanner() {
  const { hasUsRestrictedDataAccess, isLoading } =
    useStableUsRestrictedDataAccess()
  if (isLoading || hasUsRestrictedDataAccess) return null

  return (
    <Alert
      type="info"
      showIcon
      role="status"
      style={{ margin: '16px 20px 0' }}
      message={REGION_RESTRICTED_DATA_BANNER_MESSAGE}
    />
  )
}
